import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import { MobileModal } from "./MobileModal";
import styles from "./MobileOptionPicker.module.css";

interface Option {
  label: string;
  value: any;
  disabled?: boolean;
}

interface MobileOptionPickerProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  options: Option[];
  value?: any;
  onChange: (value: any) => void;
  footerText?: string;
}

const cx = (...classNames: Array<string | false>) => classNames.filter(Boolean).join(" ");

export const MobileOptionPicker: React.FC<MobileOptionPickerProps> = ({
  visible,
  onClose,
  title,
  options,
  value,
  onChange,
  footerText = "",
}) => {
  const handleSelect = (val: any, disabled?: boolean) => {
    if (disabled) return;
    onChange(val);
    onClose();
  };

  return (
    <MobileModal
      visible={visible}
      onClose={onClose}
      title={title}
      footerText={footerText}
    >
      <div className={styles.optionsList}>
        {options.map((opt) => {
          const isSelected = value === opt.value;
          const isDisabled = opt.disabled || false;
          return (
            <div
              key={String(opt.value)}
              onClick={() => handleSelect(opt.value, isDisabled)}
              className={cx(
                styles.optionItem,
                isSelected && styles.selected,
                isDisabled && styles.disabled
              )}
              // onMouseEnter={(e) => {
              //   if (!isSelected) e.currentTarget.style.backgroundColor = "#fafafa";
              // }}
              // onMouseLeave={(e) => {
              //   if (!isSelected) e.currentTarget.style.backgroundColor = "transparent";
              // }}
            >
              <span className={styles.label}>{opt.label}</span>
              {isSelected && <CheckOutlined />}
            </div>
          );
        })}
      </div>
    </MobileModal>
  );
};
